import along from "@turf/along"
import { lineString } from "@turf/helpers"
import length from "@turf/length"
import _ from "lodash"

export const isArrayOfLngLat = (value) =>
  _.isArray(value) &&
  _.every(
    value,
    (coord) => _.isArray(coord) && (coord.length === 2 || coord.length === 3)
  )

export const sampleLineStringByDistance = (coords) => {
  const line = lineString(coords)
  const spacing = 1 // meters
  const totalLength = length(line, { units: "meters" })
  const sampleLine = []
  //redraw navigation path and point in the path to have equal distance between point while remains the same shape
  for (let distance = 0; distance <= totalLength; distance += spacing) {
    const pointInPath = along(line, distance, { units: "meters" })
    sampleLine.push(pointInPath.geometry.coordinates)
  }
  return sampleLine
}
